const newRelic: any =
  typeof window !== 'undefined' && (window as any).newrelic ? (window as any).newrelic : {};

/**
 * A function for capturing errors in catch blocks and sending to New Relic
 *
 * @param {Error} error - The error being caught and sent to New Relic
 * @param {Object} data - extra data that you want to send to New Relic, like operation name and status
 */
export const logErrorNewRelic = (error: Error, data: Record<string, unknown>) => {
  // Log errors/messages in production
  if (!error.stack && typeof (Error as any).captureStackTrace === 'function') {
    (Error as any).captureStackTrace(error, Error);
  }
  if (
    typeof window !== 'undefined' &&
    (window as any).newrelic &&
    typeof newRelic.noticeError === 'function'
  ) {
    newRelic.noticeError(error, data);
  }
};

/**
 * A function for capturing page actions and sending to New Relic
 *
 * @param {String} operationName - The name of the page action to log
 * @param {Object} data - data - extra data that you want to send to New Relic, like operation name
 */
export const logPageAction = (operationName: string, data: Record<string, unknown>) => {
  if (
    typeof window !== 'undefined' &&
    (window as any).newrelic &&
    typeof newRelic.addPageAction === 'function'
  ) {
    newRelic.addPageAction(operationName, data);
  }
};
